export const ACTIVE_SUBSCRIPTION = 'ACTIVE';
export const CANCELLED_SUBSCRIPTION = 'CANCELLED';
export const PENDING_SUBSCRIPTION = 'PENDING_CANCEL';
export const SUSPENDED_SUBSCRIPTION = 'SUSPENDED';
